import androidx.compose.runtime.CompositionLocalProvider
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.RoutePrefix
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.silk.components.animation.registerKeyframes
import com.varabyte.kobweb.silk.defer.renderWithDeferred
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

public fun main() {
    RoutePrefix.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register("/") { com.itami.itami_mobile.pages.HomePage() }

    }
    router.setLegacyRouteRedirectStrategy(Router.LegacyRouteRedirectStrategy.ALLOW)
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.sections.contact.components.ContactCardStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.sections.footer.FooterStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.sections.nav_header.NavHeaderStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.sections.nav_header.components.AppLogoStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.sections.nav_header.components.NavBarStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.sections.nav_header.components.SideMenuStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.sections.start.components.SkillSectionDividerStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.sections.start.components.StartSectionGridStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.sections.start.components.StartSectionImageStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.sections.works.components.WorkItemStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.sections.works.components.WorkItemImageStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.sections.works.components.WorkItemOverlayStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.widgets.section.SectionContainerStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.components.widgets.skill.SkillItemStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.theme.fonts.TextStyle)
        ctx.theme.registerComponentStyle(com.itami.itami_mobile.theme.icons.IconStyle)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.sections.about.AboutSectionVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.sections.about.components.AboutSectionSkillsGridVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.sections.contact.ContactSectionVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.sections.nav_header.components.NavBarLinkVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.sections.nav_header.components.ActiveNavBarLinkVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.sections.nav_header.components.SideMenuLinkVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.sections.nav_header.components.ActiveSideMenuLinkVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.sections.start.StartSectionVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.sections.works.components.WorkItemsSimpleGridVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.widgets.button.IconButtonVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.widgets.button.PrimaryIconButtonVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.widgets.button.LinkIconButtonVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.widgets.button.PrimaryButtonVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.widgets.button.PrimaryButtonWithIconPadding)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.components.widgets.skill.SkillItemImageVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.fonts.TextStylePrimaryColor)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.fonts.TextStyleSecondaryColor)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.fonts.TextStyleBrandColor)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.fonts.DisplayTextStyle)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.fonts.SubDisplayTextStyle)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.fonts.TitleTextStyle)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.fonts.LabelLargeTextStyle)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.fonts.LabelMediumTextStyle)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.fonts.BodyLargeTextStyle)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.fonts.BodyMediumTextStyle)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.fonts.BodySmallTextStyle)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.icons.IconBrandColorVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.icons.IconOnBrandColorVariant)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.icons.LargeIconSize)
        ctx.theme.registerComponentVariants(com.itami.itami_mobile.theme.icons.MediumIconSize)
        ctx.stylesheet.registerKeyframes(com.itami.itami_mobile.components.sections.nav_header.components.SideMenuSlideInAnim)
        ctx.stylesheet.registerKeyframes(com.itami.itami_mobile.components.sections.start.components.StartSectionGridKeyFrames)
        com.itami.itami_mobile.initColorMode(ctx)
        com.itami.itami_mobile.theme.initAppStyles(ctx)
        com.itami.itami_mobile.theme.initSilkPalette(ctx)
    }

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    router.navigateTo(window.location.href.removePrefix(window.location.origin),
            UpdateHistoryMode.REPLACE)

    val root = document.getElementById("root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    AppGlobals.initialize(mapOf("title" to "Itami Mobile"))
    renderComposable(rootElementId = "root") {
        com.itami.itami_mobile.AppEntry {
            router.renderActivePage { renderWithDeferred { it() } }
        }
    }
}
